import cloneDeep from 'lodash/cloneDeep';

import LinkData from 'redpoints-model-js/model/linkdata/LinkData';

import { fetchReducerGenerator } from 'redpoints-front-common/reducers';
import { getNewLinkDataByLinkServiceResponse } from 'redpoints-front-common/services';

import {
  INCIDENT_DETAILS_CLEAR,
  INCIDENT_DETAILS_FETCH_DETECTION_LINK_DATA,
  INCIDENT_DETAILS_SAVE_DETECTION_LINK_ERROR,
  INCIDENT_DETAILS_SAVE_DETECTION_LINK_FAILURE,
  INCIDENT_DETAILS_SAVE_DETECTION_LINK_SUCCESS,
} from '../../../../actions/actionTypes';

export const additionalActionsReducer = (state, action) => {
  switch (action.type) {
    case INCIDENT_DETAILS_SAVE_DETECTION_LINK_ERROR:
    case INCIDENT_DETAILS_SAVE_DETECTION_LINK_FAILURE:
    case INCIDENT_DETAILS_SAVE_DETECTION_LINK_SUCCESS: {
      const newState = cloneDeep(state);
      const linkData = state.data || new LinkData();
      newState.data = getNewLinkDataByLinkServiceResponse(linkData, action);
      return newState;
    }
    default:
      return state;
  }
};

const detectionLinkDataOriginal = fetchReducerGenerator(
  INCIDENT_DETAILS_CLEAR,
  INCIDENT_DETAILS_FETCH_DETECTION_LINK_DATA,
  additionalActionsReducer
);

export default detectionLinkDataOriginal;
